import React from "react"
import styled from "styled-components/macro"
import colors from "../../scripts/colors"
import Icon from "../../images/iconmonstr-arrow-24---outline.svg"
import "@fontsource/noto-sans-jp/900.css"

const PageTitleStyles = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto 60px;
  h1 {
    margin: 0 0 27px;
    font-size: 50px;
    font-weight: 900;
    line-height: 1em;
    text-align: center;
  }
`

const PageTitleDecoration = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

const PageTitleLine = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 3px;
  width: 210px;
  background-color: ${colors("grey", "xlt")};
`

const PageTitleIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  /* transform: rotate(90deg); */
  height: 27px;
  color: ${colors("purple")};
`

const PageTitle: React.FC = ({ children }) => {
  return (
    <PageTitleStyles>
      <h1>{children}</h1>
      <PageTitleDecoration>
        <PageTitleLine></PageTitleLine>
        <PageTitleIcon>
          <Icon />
        </PageTitleIcon>
      </PageTitleDecoration>
    </PageTitleStyles>
  )
}

export default PageTitle
